import type { TConstraints } from '@feathr/rachis';

import { TargetableClass } from './targetable.types';
import type { ITargetableBase } from './targetable_base';
import { TargetableBase } from './targetable_base';

/**
 * Interface for search targetables
 */
export interface ISearchTargetable extends ITargetableBase {
  _cls: TargetableClass.search;
  // This doesn't seem to be populating
  search_keywords?: string[];
  src_search_keywords: string;
  src_filename: string;
  num_keywords: number;
}

/**
 * SearchTargetable class for search keyword targetables
 */
export class SearchTargetable extends TargetableBase<ISearchTargetable> {
  public override className = 'Targetable.SearchTargetable';

  public override getDefaults(): Partial<ISearchTargetable> {
    return {
      ...super.getDefaults(),
      _cls: TargetableClass.search,
    };
  }

  public override get constraints(): TConstraints<ISearchTargetable> {
    return {
      ...super.constraints,
      _cls: {
        inclusion: [TargetableClass.search],
      },
      src_filename: {
        presence: {
          allowEmpty: false,
          message: '^Please upload a keyword list.',
        },
      },
      num_keywords: {
        numericality: {
          greaterThanOrEqualTo: 1,
          notGreaterThanOrEqualTo: '^Please upload a keyword list with at least 1 search term.',
        },
      },
    };
  }
}
